var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg_({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "241.69531pt",
    height: "603.73438pt",
    viewBox: "0 0 241.69531 603.73437",
    id: "svg1363",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 3.75,4.59375 c -0.125,0.289062 -0.433594,0.4375 -0.921875,0.4375 -0.125,0 -0.257813,-0.023438 -0.390625,-0.0625 L 1.734375,4.78125 C 0.960938,4.582031 0.445312,4.175781 0.1875,3.5625 0.0625,3.257812 0,2.910156 0,2.515625 v -1.34375 c 0,-0.230469 0.113281,-0.34375 0.34375,-0.34375 0.238281,0 0.359375,0.113281 0.359375,0.34375 v 1.53125 C 0.703125,3.003906 0.800781,3.285156 1,3.546875 1.195312,3.816406 1.441406,3.988281 1.734375,4.0625 L 2.4375,4.25 c 0.144531,0.039062 0.273438,0.0625 0.390625,0.0625 0.4375,0 0.65625,-0.289062 0.65625,-0.859375 v -0.625 c 0,-0.242187 0.113281,-0.359375 0.34375,-0.359375 0.226563,0 0.34375,0.117188 0.34375,0.359375 v 0.8125 c 0,0.414063 0.171875,0.773437 0.515625,1.078125 C 4.851562,4.863281 5.03125,4.957031 5.21875,5 c 0.113281,0.03125 0.21875,0.046875 0.3125,0.046875 0.488281,0 0.734375,-0.28125 0.734375,-0.84375 V 2.84375 C 6.265625,2.613281 6.378906,2.5 6.609375,2.5 c 0.226563,0 0.34375,0.113281 0.34375,0.34375 v 1.546875 c 0,0.539063 -0.246094,0.9375 -0.734375,1.1875 C 6.007812,5.691406 5.785156,5.75 5.546875,5.75 5.429688,5.75 5.320312,5.738281 5.21875,5.71875 4.457031,5.519531 3.96875,5.144531 3.75,4.59375 Z m 0,0",
    id: "path1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0.703125,2.703125 c 0,0.71875 0.34375,1.171875 1.03125,1.359375 L 2.4375,4.25 c 0.132812,0.039062 0.265625,0.0625 0.390625,0.0625 0.4375,0 0.65625,-0.292969 0.65625,-0.875 V 2.359375 l -1.75,-0.453125 C 1.628906,1.875 1.546875,1.859375 1.484375,1.859375 1.242188,1.859375 1.050781,1.9375 0.90625,2.09375 0.769531,2.257812 0.703125,2.460938 0.703125,2.703125 Z M 0,2.515625 C 0,2.023438 0.253906,1.632812 0.765625,1.34375 c 0.21875,-0.136719 0.445313,-0.203125 0.6875,-0.203125 0.09375,0 0.1875,0.015625 0.28125,0.046875 L 3.828125,1.75 C 4.597656,1.945312 5.242188,2.289062 5.765625,2.78125 6.347656,3.332031 6.738281,4.046875 6.9375,4.921875 6.945312,4.941406 6.953125,4.96875 6.953125,5 c 0,0.238281 -0.117187,0.359375 -0.34375,0.359375 C 6.410156,5.359375 6.300781,5.28125 6.28125,5.125 6.226562,4.738281 6.082031,4.347656 5.84375,3.953125 5.414062,3.242188 4.859375,2.789062 4.171875,2.59375 V 3.640625 C 4.171875,4.035156 4.039062,4.363281 3.78125,4.625 3.53125,4.882812 3.207031,5.015625 2.8125,5.015625 2.675781,5.015625 2.550781,5 2.4375,4.96875 L 1.734375,4.78125 C 0.921875,4.5625 0.398438,4.171875 0.171875,3.609375 0.0546875,3.316406 0,2.953125 0,2.515625 Z m 0,0",
    id: "path2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3.421875,4.921875 0.15625,2.90625 C 0.0507812,2.84375 0,2.742188 0,2.609375 c 0,-0.09375 0.0351562,-0.179687 0.109375,-0.25 0.070313,-0.0625 0.15625,-0.09375 0.25,-0.09375 L 6.609375,2.5 c 0.226563,0 0.34375,0.113281 0.34375,0.34375 0,0.25 -0.121094,0.367188 -0.359375,0.359375 L 1.640625,3 4.703125,4.875 C 4.816406,4.9375 4.875,5.03125 4.875,5.15625 4.875,5.382812 4.765625,5.503906 4.546875,5.515625 L 1.59375,5.75 6.765625,8.296875 c 0.125,0.0625 0.1875,0.164063 0.1875,0.3125 0,0.226563 -0.117187,0.34375 -0.34375,0.34375 -0.054687,0 -0.105469,-0.011719 -0.15625,-0.03125 L 0.1875,5.8125 C 0.0625,5.75 0,5.648438 0,5.515625 0,5.285156 0.109375,5.164062 0.328125,5.15625 Z m 0,0",
    id: "path3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.703125,4.046875 C 0.703125,4.285156 0.582031,4.40625 0.34375,4.40625 0.113281,4.40625 0,4.285156 0,4.046875 V 1.078125 C 0,0.972656 0.03125,0.894531 0.09375,0.84375 0.164062,0.789062 0.25,0.78125 0.34375,0.8125 L 6.6875,2.515625 c 0.175781,0.050781 0.265625,0.160156 0.265625,0.328125 0,0.238281 -0.117187,0.359375 -0.34375,0.359375 -0.042969,0 -0.074219,-0.00781 -0.09375,-0.015625 L 0.703125,1.625 Z m 0,0",
    id: "path4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3.484375,4.265625 V 2.375 L 0.703125,1.625 V 4.046875 C 0.703125,4.285156 0.582031,4.40625 0.34375,4.40625 0.113281,4.40625 0,4.285156 0,4.046875 V 1.078125 C 0,0.972656 0.03125,0.894531 0.09375,0.84375 0.164062,0.789062 0.25,0.78125 0.34375,0.8125 l 6.265625,1.671875 c 0.226563,0.0625 0.34375,0.21875 0.34375,0.46875 V 5.71875 c 0,0.238281 -0.117187,0.359375 -0.34375,0.359375 -0.230469,0 -0.34375,-0.121094 -0.34375,-0.359375 V 3.125 L 4.171875,2.5625 v 1.703125 c 0,0.226563 -0.117187,0.34375 -0.34375,0.34375 -0.230469,0 -0.34375,-0.117187 -0.34375,-0.34375 z m 0,0",
    id: "path5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 6.609375,2.484375 c 0.226563,0.0625 0.34375,0.21875 0.34375,0.46875 v 2.15625 c 0,0.363281 -0.15625,0.679687 -0.46875,0.953125 -0.304687,0.28125 -0.636719,0.421875 -1,0.421875 C 5.398438,6.484375 5.3125,6.46875 5.21875,6.4375 L 1.734375,5.515625 C 0.578125,5.203125 0,4.441406 0,3.234375 V 1.078125 C 0,0.972656 0.03125,0.894531 0.09375,0.84375 0.164062,0.789062 0.25,0.78125 0.34375,0.8125 Z M 6.265625,3.125 0.703125,1.625 V 3.421875 C 0.703125,3.722656 0.800781,4.003906 1,4.265625 1.195312,4.535156 1.441406,4.707031 1.734375,4.78125 L 5.21875,5.71875 C 5.3125,5.738281 5.394531,5.75 5.46875,5.75 c 0.238281,0 0.429688,-0.078125 0.578125,-0.234375 0.144531,-0.15625 0.21875,-0.355469 0.21875,-0.59375 z m 0,0",
    id: "path6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,5.140625 V 3.921875 H 7.734375 C 7.453125,3.628906 7.171875,3.242188 6.890625,2.765625 6.609375,2.296875 6.398438,1.875 6.265625,1.5 H 7.4375 c 0.320312,0.675781 0.707031,1.269531 1.15625,1.78125 0.457031,0.507812 0.898438,0.867188 1.328125,1.078125 v 0.78125 z m 0,0",
    id: "path7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 4.875,0.578125 c 1.164062,0 2.101562,0.117187 2.8125,0.359375 C 8.394531,1.175781 8.941406,1.53125 9.328125,2 9.722656,2.476562 9.921875,3.078125 9.921875,3.796875 9.921875,4.328125 9.8125,4.789062 9.59375,5.1875 9.382812,5.582031 9.078125,5.910156 8.671875,6.171875 8.273438,6.429688 7.785156,6.632812 7.203125,6.78125 6.628906,6.9375 5.851562,7.015625 4.875,7.015625 3.707031,7.015625 2.769531,6.894531 2.0625,6.65625 1.351562,6.414062 0.800781,6.054688 0.40625,5.578125 c -0.3867188,-0.46875 -0.578125,-1.0625 -0.578125,-1.78125 0,-0.960937 0.34375,-1.710937 1.03125,-2.25 C 1.679688,0.898438 3.019531,0.578125 4.875,0.578125 Z m 0,1.234375 C 3.25,1.8125 2.164062,2 1.625,2.375 1.09375,2.757812 0.828125,3.234375 0.828125,3.796875 c 0,0.550781 0.269531,1.015625 0.8125,1.390625 C 2.179688,5.570312 3.257812,5.765625 4.875,5.765625 6.5,5.765625 7.578125,5.570312 8.109375,5.1875 8.640625,4.8125 8.90625,4.34375 8.90625,3.78125 8.90625,3.21875 8.671875,2.773438 8.203125,2.453125 7.597656,2.023438 6.488281,1.8125 4.875,1.8125 Z m 0,0",
    id: "path8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1.015625 H 9.875 V 2.3125 H 1.171875 v 4.875 H 0 Z m 0,0",
    id: "path9"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g1364",
    transform: "translate(-20.09375,-120.29297)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00209533,-1.98e-4 H -56.159363 m -8.322917,0 h -8.479166 m -8.317709,0 h -8.322916 m -8.479167,0 h -41.760412 m -8.47917,0 h -8.31771 m -8.32292,0 h -8.47916 m -8.31771,0 h -41.92188 m -8.3177,0 h -8.48438 m -8.31771,0 h -8.31771",
    transform: "matrix(0.75,0,0,0.75,261.59999,723.83999)",
    id: "path1159"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 83.197917,965.1198 H 27.041667 V 918.71875",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1160"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 0.00166567,0.001023 v -8.322917 m 0,-8.479166 v -8.317709 m 0,-8.322916 v -41.916667 m 0,-8.322917 v -8.479166 m 0,-8.317705 v -8.32292 m 0,-8.47917 v -41.92187 m 0,-8.31771 v -8.31771 m 0,-8.48437 v -8.31771 m 0,-8.32292 v -41.91666 m 0,-8.32292 v -8.47917 m 0,-8.31771 v -8.32291 m 0,-8.47917 v -41.76042 m 0,-8.47916 v -8.31771 m 0,-8.32292 v -8.47916 m 0,-8.31771 v -41.92188 m 0,-8.31771 v -8.32291 m 0,-8.47917 v -8.31771 m 0,-8.32291 v -41.92188 m 0,-8.47917 v -8.3177 m 0,-8.32292 v -8.47917 m 0,-8.31771 v -41.92187 m 0,-8.31771 v -8.32292 m 0,-8.47916 v -8.31771 m 0,-8.32292 v -41.91666 m 0,-8.32292 v -8.47917 m 0,-8.31771 v -8.32291",
    transform: "matrix(0.75,0,0,0.75,20.280001,682.80001)",
    id: "path1161"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 27.041667,206.88021 v -46.23958 h 56.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1162"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00229167,6.31333e-4 H 8.32 m 8.317708,0 h 8.484375 m 8.317709,0 h 41.921875 m 8.317708,0 h 8.479167 m 8.322918,0 h 8.31771 m 8.47916,0 h 41.76042 m 8.47917,0 h 8.32291 m 8.31771,0 h 8.47917",
    transform: "matrix(0.75,0,0,0.75,68.76,120.48)",
    id: "path1163"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 292.64062,160.64063 h 56.16146 v 46.23958",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1164"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00209533,-6.20667e-4 V 8.322296 m 0,8.317708 v 8.479167 m 0,8.322917 v 41.916666 m 0,8.322917 v 8.317708 m 0,8.479171 v 8.32291 m 0,8.31771 v 41.92188 m 0,8.3177 v 8.47917 m 0,8.32292 v 8.31771 m 0,8.47916 v 41.92188 m 0,8.32291 v 8.31771 m 0,8.47917 v 8.32292 m 0,8.3177 v 41.92188 m 0,8.31771 v 8.47916 m 0,8.32292 v 8.31771 m 0,8.47917 v 41.76041 m 0,8.47917 v 8.32292 m 0,8.3177 v 8.47917 m 0,8.32292 v 41.91666 m 0,8.32292 v 8.31771 m 0,8.48437 v 8.31771 m 0,8.31771 v 41.92188 m 0,8.47916 v 8.32292 m 0,8.31771 v 8.47916 m 0,8.32292 v 41.91667 m 0,8.32291 v 8.31771 m 0,8.47917 v 8.32292",
    transform: "matrix(0.75,0,0,0.75,261.59999,161.52)",
    id: "path1165"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 348.80208,918.71875 V 965.1198",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1166"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 261.60156,120.48047 -0.24219,17.75781 v -17.75781 z m 0,0",
    id: "path1167"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 261.60156,120.48047 v 17.75781 h -0.24219 z m 0,0",
    id: "path1168"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 261.35937,138 -2.64062,0.23828 V 138 Z m 0,0",
    id: "path1169"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 261.35937,138 v 0.23828 h -2.64062 z m 0,0",
    id: "path1170"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 258.71875,135.71875 -0.35938,2.51953 v -2.51953 z m 0,0",
    id: "path1171"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 258.71875,135.71875 v 2.51953 h -0.35938 z m 0,0",
    id: "path1172"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 249.35937,123.48047 -2.28125,0.23828 v -0.23828 z m 0,0",
    id: "path1173"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 249.35937,123.48047 v 0.23828 h -2.28125 z m 0,0",
    id: "path1174"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 261.35937,120.48047 -14.28125,0.23828 v -0.23828 z m 0,0",
    id: "path1175"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 261.35937,120.48047 v 0.23828 h -14.28125 z m 0,0",
    id: "path1176"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 247.07812,120.48047 -0.23828,3.23828 v -3.23828 z m 0,0",
    id: "path1177"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 247.07812,120.48047 v 3.23828 h -0.23828 z m 0,0",
    id: "path1178"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -2.03333e-4,6.31333e-4 H 19.682088 M 0.317505,0.31834 H 19.359172 M 19.682088,6.31333e-4 V 23.677715 M 19.359172,0.31834 v 23.041666 m 0.322916,0.317709 h -4.322916 m 4,-0.317709 h -3.520834 m -0.479166,0.317709 V 20.31834 m 0.479166,3.041666 V 20.31834 M -2.03333e-4,6.31333e-4 V 4.31834 m 0.317708333,-4 V 4.000631 M -2.03333e-4,4.31834 H 3.359172",
    transform: "matrix(0.75,0,0,0.75,246.84,120.48)",
    id: "path1179"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 329.4375,164.64063 h 3.04167 v 0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1180"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00165767,-0.00166833 H -0.480824 M -5.277699,-16.001668 v 1.442708 m 0,0.479167 v 1.4375 m 0,0.484375 v 1.598958 m 0,0.317708 v 1.598959 m 0,0.484375 v 1.598958 m 0,0.317708 v 1.598959",
    transform: "matrix(0.75,0,0,0.75,258.71999,135.72)",
    id: "path1181"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 339.68229,176.64063 v 1.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1182"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m -6.1e-4,-1.98e-4 h 1.442708 m 0.317709,0 h 1.598958 m 0.479167,0 H 5.28064 m 0.479167,0 h 1.598958 m 0.322917,0 H 9.28064 m 0.479167,0 h 1.598958",
    transform: "matrix(0.75,0,0,0.75,248.51999,135.83999)",
    id: "path1183"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 343.04167,181.1198 h 1.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1184"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 20.28125,120.48047 0.359375,17.75781 v -17.75781 z m 0,0",
    id: "path1185"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 20.28125,120.48047 v 17.75781 h 0.359375 z m 0,0",
    id: "path1186"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 20.640625,138 2.640625,0.23828 V 138 Z m 0,0",
    id: "path1187"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 20.640625,138 v 0.23828 h 2.640625 z m 0,0",
    id: "path1188"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 23.28125,135.71875 0.238281,2.51953 v -2.51953 z m 0,0",
    id: "path1189"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 23.28125,135.71875 v 2.51953 h 0.238281 z m 0,0",
    id: "path1190"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 32.519531,123.48047 2.28125,0.23828 v -0.23828 z m 0,0",
    id: "path1191"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 32.519531,123.48047 v 0.23828 h 2.28125 z m 0,0",
    id: "path1192"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 20.640625,120.48047 14.160156,0.23828 v -0.23828 z m 0,0",
    id: "path1193"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 20.640625,120.48047 v 0.23828 h 14.160156 z m 0,0",
    id: "path1194"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 34.800781,120.48047 0.359375,3.23828 v -3.23828 z m 0,0",
    id: "path1195"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 34.800781,120.48047 v 3.23828 h 0.359375 z m 0,0",
    id: "path1196"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 2.07333e-4,6.31333e-4 H -19.838334 M -0.478959,0.31834 H -19.359168 M -19.838334,6.31333e-4 V 23.677715 M -19.359168,0.31834 v 23.041666 m -0.479166,0.317709 h 4.317708 m -3.838542,-0.317709 h 3.520834 m 0.317708,0.317709 V 20.31834 m -0.317708,3.041666 V 20.31834 M 2.07333e-4,6.31333e-4 V 4.31834 m -0.479166333,-4 V 4.000631 M 2.07333e-4,4.31834 H -3.520626",
    transform: "matrix(0.75,0,0,0.75,35.160001,120.48)",
    id: "path1197"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 46.401042,164.64063 h -3.041667 v 0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1198"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00166567,-0.00166833 H 0.319374 M 5.277707,-16.001668 v 1.442708 m 0,0.479167 v 1.4375 m 0,0.484375 v 1.598958 m 0,0.317708 v 1.598959 m 0,0.484375 v 1.598958 m 0,0.317708 v 1.598959",
    transform: "matrix(0.75,0,0,0.75,23.280001,135.72)",
    id: "path1199"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 36.317708,176.64063 v 1.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1200"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 6.26e-4,-1.98e-4 h -1.442708 m -0.479167,0 h -1.598958 m -0.317709,0 h -1.604166 m -0.479167,0 h -1.4375 m -0.479167,0 h -1.604166 m -0.317709,0 h -1.598958",
    transform: "matrix(0.75,0,0,0.75,33.479999,135.83999)",
    id: "path1201"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 32.802083,181.1198 H 31.359375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1202"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 261.60156,723.83984 -0.24219,-17.8789 v 17.8789 z m 0,0",
    id: "path1203"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 261.60156,723.83984 v -17.8789 h -0.24219 z m 0,0",
    id: "path1204"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 261.35937,706.32031 -2.64062,-0.35937 v 0.35937 z m 0,0",
    id: "path1205"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 261.35937,706.32031 v -0.35937 h -2.64062 z m 0,0",
    id: "path1206"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 258.71875,708.60156 -0.35938,-2.64062 v 2.64062 z m 0,0",
    id: "path1207"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 258.71875,708.60156 v -2.64062 h -0.35938 z m 0,0",
    id: "path1208"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 249.35937,720.83984 -2.28125,-0.23828 v 0.23828 z m 0,0",
    id: "path1209"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 249.35937,720.83984 v -0.23828 h -2.28125 z m 0,0",
    id: "path1210"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 261.35937,723.83984 -14.28125,-0.35937 v 0.35937 z m 0,0",
    id: "path1211"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 261.35937,723.83984 v -0.35937 h -14.28125 z m 0,0",
    id: "path1212"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 247.07812,723.83984 -0.23828,-3.23828 v 3.23828 z m 0,0",
    id: "path1213"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 247.07812,723.83984 v -3.23828 h -0.23828 z m 0,0",
    id: "path1214"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -2.03333e-4,-1.98e-4 H 19.682088 M 0.317505,-0.479365 h 19.041667 m 0.322916,0.479167 V -23.83874 m -0.322916,23.359375 v -22.880208 m 0.322916,-0.479167 h -4.322916 m 4,0.479167 h -3.520834 m -0.479166,-0.479167 v 3.520834 m 0.479166,-3.041667 v 3.041667 M -2.03333e-4,-1.98e-4 V -4.317906 M 0.317505,-0.479365 V -4.000198 M -2.03333e-4,-4.317906 H 3.359172",
    transform: "matrix(0.75,0,0,0.75,246.84,723.83999)",
    id: "path1215"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 329.4375,961.1198 h 3.04167 v -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1216"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00165767,0.00210067 H -0.480824 M -5.277699,16.002101 v -1.442709 m 0,-0.479166 v -1.598959 m 0,-0.322916 v -1.598959 m 0,-0.479166 V 8.481267 m 0,-0.322916 V 6.559392 m 0,-0.317708 V 4.637517",
    transform: "matrix(0.75,0,0,0.75,258.71999,708.59999)",
    id: "path1217"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 339.68229,948.95834 v -1.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1218"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m -6.1e-4,6.15333e-4 h 1.442708 m 0.317709,0 h 1.598958 m 0.479167,0 H 5.28064 m 0.479167,0 h 1.598958 m 0.322917,0 H 9.28064 m 0.479167,0 h 1.598958",
    transform: "matrix(0.75,0,0,0.75,248.51999,708.48001)",
    id: "path1219"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 343.04167,944.64063 h 1.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1220"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 20.28125,723.83984 0.359375,-17.8789 v 17.8789 z m 0,0",
    id: "path1221"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 20.28125,723.83984 v -17.8789 h 0.359375 z m 0,0",
    id: "path1222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 20.640625,706.32031 2.640625,-0.35937 v 0.35937 z m 0,0",
    id: "path1223"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 20.640625,706.32031 v -0.35937 h 2.640625 z m 0,0",
    id: "path1224"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 23.28125,708.60156 0.238281,-2.64062 v 2.64062 z m 0,0",
    id: "path1225"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 23.28125,708.60156 v -2.64062 h 0.238281 z m 0,0",
    id: "path1226"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 32.519531,720.83984 2.28125,-0.23828 v 0.23828 z m 0,0",
    id: "path1227"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 32.519531,720.83984 v -0.23828 h 2.28125 z m 0,0",
    id: "path1228"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 20.640625,723.83984 14.160156,-0.35937 v 0.35937 z m 0,0",
    id: "path1229"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 20.640625,723.83984 v -0.35937 h 14.160156 z m 0,0",
    id: "path1230"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 34.800781,723.83984 0.359375,-3.23828 v 3.23828 z m 0,0",
    id: "path1231"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 34.800781,723.83984 v -3.23828 h 0.359375 z m 0,0",
    id: "path1232"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 2.07333e-4,-1.98e-4 H -19.838334 m 19.359375,-0.479167 h -18.880209 m -0.479166,0.479167 V -23.83874 m 0.479166,23.359375 v -22.880208 m -0.479166,-0.479167 h 4.317708 m -3.838542,0.479167 h 3.520834 m 0.317708,-0.479167 v 3.520834 m -0.317708,-3.041667 v 3.041667 M 2.07333e-4,-1.98e-4 V -4.317906 M -0.478959,-0.479365 V -4.000198 M 2.07333e-4,-4.317906 H -3.520626",
    transform: "matrix(0.75,0,0,0.75,35.160001,723.83999)",
    id: "path1233"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 46.401042,961.1198 h -3.041667 v -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1234"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00166567,0.00210067 H 0.319374 M 5.277707,16.002101 v -1.442709 m 0,-0.479166 v -1.598959 m 0,-0.322916 v -1.598959 m 0,-0.479166 V 8.481267 m 0,-0.322916 V 6.559392 m 0,-0.317708 V 4.637517",
    transform: "matrix(0.75,0,0,0.75,23.280001,708.59999)",
    id: "path1235"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 36.317708,948.95834 v -1.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1236"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 6.26e-4,6.15333e-4 h -1.442708 m -0.479167,0 h -1.598958 m -0.317709,0 h -1.604166 m -0.479167,0 h -1.4375 m -0.479167,0 h -1.604166 m -0.317709,0 h -1.598958",
    transform: "matrix(0.75,0,0,0.75,33.479999,708.48001)",
    id: "path1237"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 32.802083,944.64063 H 31.359375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1238"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -2.03333e-4,-0.00104233 2.077922,-0.162501 l 2.083333,-0.635416 1.916667,-0.802084 1.604166,-1.28125 1.4375,-1.4375 1.28125,-1.760416 0.796875,-1.760417 0.640625,-2.078125 0.161459,-2.083333 -0.161459,-2.078125 -0.640625,-2.083334 -0.796875,-1.916666 -1.28125,-1.598959 -1.4375,-1.442708 -1.604166,-1.28125 -1.916667,-0.796875 -2.083333,-0.640625 -2.078125333,-0.161458 -2.078124667,0.161458 -2.083334,0.640625 -1.760416,0.796875 -1.760417,1.28125 -1.4375,1.442708 -1.28125,1.598959 -0.796875,1.916666 -0.640625,2.083334 -0.161458,2.078125 0.161458,2.083333 0.640625,2.078125 0.796875,1.760417 1.28125,1.760416 1.4375,1.4375 1.760417,1.28125 1.760416,0.802084 2.083334,0.635416 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,210.84,346.2)",
    id: "path1239"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 291.83854,449.59896 h -5.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1240"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -2.03333e-4,0.00145967 1.921672,-0.159999 l 1.916666,-0.479166 1.760417,-0.958334 1.442708,-1.125 1.4375,-1.4375 0.963542,-1.760416 0.635417,-1.760417 0.484375,-1.916667 v -1.921875 l -0.484375,-1.921875 -0.635417,-1.760416 -0.963542,-1.760417 -1.4375,-1.4375 -1.442708,-1.119792 -1.760417,-0.958333 -1.916666,-0.484375 -1.921875333,-0.15625 -1.921874667,0.15625 -1.916667,0.484375 -1.760417,0.958333 -1.442708,1.119792 -1.4375,1.4375 -0.958333,1.760417 -0.640625,1.760416 -0.479167,1.921875 v 1.921875 l 0.479167,1.916667 0.640625,1.760417 0.958333,1.760416 1.4375,1.4375 1.442708,1.125 1.760417,0.958334 1.916667,0.479166 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,210.84,345.12)",
    id: "path1241"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 251.35937,399.35938 h 79.04167 m -79.04167,65.92187 h 79.04167 m -79.04167,-65.92187 h 79.04167",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1242"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -4.06667e-4,-6.04667e-4 1.921468,-0.162063 3.681885,-0.79748 l 1.760417,-0.802083 1.4375,-1.28125 1.28125,-1.4375 0.796875,-1.760417 0.640625,-1.760416 0.161458,-1.921875 -0.161458,-1.916667 -0.640625,-1.760417 -0.796875,-1.760416 -1.28125,-1.442709 -1.4375,-1.28125 -1.760417,-0.796875 -1.760417,-0.640625 -1.921874667,-0.161458 -1.921875333,0.161458 -1.755208,0.640625 -1.760417,0.796875 -1.442708,1.28125 -1.28125,1.442709 -0.796875,1.760416 -0.640625,1.760417 -0.161458,1.916667 0.161458,1.921875 0.640625,1.760416 0.796875,1.760417 1.28125,1.4375 1.442708,1.28125 1.760417,0.802083 1.755208,0.635417 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,235.67999,344.51999)",
    id: "path1243"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 8.44333e-4,-0.00249667 2.078969,-0.158747 l 2.083334,-0.640625 1.916666,-0.802083 1.598959,-1.276042 1.442708,-1.442708 1.28125,-1.760417 0.796875,-1.760416 0.640625,-2.078125 0.161458,-2.083334 -0.161458,-2.078125 -0.640625,-2.078125 -0.796875,-1.921875 -1.28125,-1.598958 -1.442708,-1.442708 -1.598959,-1.276042 -1.916666,-0.802083 -2.083334,-0.640625 -2.078124667,-0.161459 -2.083333333,0.161459 -2.078125,0.640625 -1.760417,0.802083 -1.760416,1.276042 -1.4375,1.442708 -1.28125,1.598958 -0.802084,1.921875 -0.635416,2.078125 -0.161459,2.078125 0.161459,2.083334 0.635416,2.078125 0.802084,1.760416 1.28125,1.760417 1.4375,1.442708 1.760416,1.276042 1.760417,0.802083 2.078125,0.640625 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,233.63999,322.08)",
    id: "path1244"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.001251,-0.00104233 H -4.318959 M -0.480418,-32.162501 h -5.4375 m -2.5625,40.640625 V 4.160416 m -2.71875,-25.598958 v -5.442709 m 0,-16 v 5.28125",
    transform: "matrix(0.75,0,0,0.75,242.04,337.2)",
    id: "path1245"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -4.06667e-4,-0.00185667 1.76001,-0.158107 l 1.760417,-0.640625 1.4375,-0.802083 1.28125,-1.28125 1.119791,-1.4375 0.640625,-1.598958 0.479167,-1.598959 v -1.921875 l -0.479167,-1.598958 -0.640625,-1.760417 -1.119791,-1.28125 -1.28125,-1.28125 -1.4375,-0.796875 -1.760417,-0.640625 -1.760416667,-0.161458 -1.760416333,0.161458 -1.760417,0.640625 -1.4375,0.796875 -1.28125,1.28125 -1.119792,1.28125 -0.640625,1.760417 -0.479166,1.598958 v 1.921875 l 0.479166,1.598959 0.640625,1.598958 1.119792,1.4375 1.28125,1.28125 1.4375,0.802083 1.760417,0.640625 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,235.67999,343.55999)",
    id: "path1246"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 305.59896,449.59896 h 4.32291 m 4.31771,-8.64062 v 4.32291",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1247"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 8.44333e-4,5.33333e-6 1.917511,-0.161453 3.839386,-0.64062 l 1.760417,-0.958333 1.442708,-1.119792 1.4375,-1.442708 0.958333,-1.760417 0.640625,-1.760416 0.479167,-1.916667 v -1.921875 l -0.479167,-1.916667 -0.640625,-1.760416 -0.958333,-1.760417 -1.4375,-1.442708 -1.442708,-1.119792 -1.760417,-0.958333 -1.921875,-0.479167 -1.916666667,-0.161458 -1.921875333,0.161458 -1.916666,0.479167 -1.760417,0.958333 -1.442708,1.119792 -1.4375,1.442708 -0.963542,1.760417 -0.640625,1.760416 -0.479167,1.916667 v 1.921875 l 0.479167,1.916667 0.640625,1.760416 0.963542,1.760417 1.4375,1.442708 1.442708,1.119792 1.760417,0.958333 1.916666,0.479167 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,233.63999,321)",
    id: "path1248"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 300.80208,417.4375 h 5.27604 m 24.32292,47.84375 v -65.92187",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1249"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 0.00104767,-0.00209 1.91666633,-0.15625 1.760417,-0.640625 1.760417,-0.802083 1.442708,-1.28125 1.28125,-1.4375 0.796875,-1.760417 0.640625,-1.760417 0.161458,-1.921875 -0.161458,-1.916666 -0.640625,-1.760417 -0.796875,-1.760417 -1.28125,-1.4375 -1.442708,-1.28125 -1.760417,-0.802083 -1.760417,-0.640625 -1.91666633,-0.15625 -1.92187467,0.15625 -1.760417,0.640625 -1.760417,0.802083 -1.4375,1.28125 -1.28125,1.4375 -0.802083,1.760417 -0.635417,1.760417 -0.161458,1.916666 0.161458,1.921875 0.635417,1.760417 0.802083,1.760417 1.28125,1.4375 1.4375,1.28125 1.760417,0.802083 1.760417,0.640625 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,208.8,320.40001)",
    id: "path1250"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,0.00186733 0.800629,-0.159591 1.597504,-0.638758 2.238129,-1.279383 2.561046,-2.081466 V -3.039799 L 2.238129,-3.841883 1.597504,-4.482508 0.800629,-4.961674 l -0.80208333,-0.15625 -0.79687467,0.15625 -0.802084,0.479166 -0.640625,0.640625 -0.317708,0.802084 v 0.958333 l 0.317708,0.802083 0.640625,0.640625 0.802084,0.479167 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,191.88,319.44001)",
    id: "path1251"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,0.00186733 0.800629,-0.159591 1.597504,-0.638758 2.238129,-1.279383 2.561046,-2.081466 V -3.039799 L 2.238129,-3.841883 1.597504,-4.482508 0.800629,-4.961674 l -0.80208333,-0.15625 -0.79687467,0.15625 -0.802084,0.479166 -0.640625,0.640625 -0.317708,0.802084 v 0.958333 l 0.317708,0.802083 0.640625,0.640625 0.802084,0.479167 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,191.88,310.44001)",
    id: "path1252"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,0.00125633 0.800629,-0.160202 1.597504,-0.639369 2.238129,-1.279994 2.561046,-2.082077 V -3.04041 L 2.238129,-3.842494 1.597504,-4.47791 0.800629,-4.962285 l -0.80208333,-0.15625 -0.79687467,0.15625 -0.802084,0.484375 -0.640625,0.635416 -0.317708,0.802084 v 0.958333 l 0.317708,0.802083 0.640625,0.640625 0.802084,0.479167 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,191.88,333.95999)",
    id: "path1253"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,0.00125633 0.800629,-0.160202 1.597504,-0.639369 2.238129,-1.279994 2.561046,-2.082077 V -3.04041 L 2.238129,-3.842494 1.597504,-4.47791 0.800629,-4.962285 l -0.80208333,-0.15625 -0.79687467,0.15625 -0.802084,0.484375 -0.640625,0.635416 -0.317708,0.802084 v 0.958333 l 0.317708,0.802083 0.640625,0.640625 0.802084,0.479167 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,191.88,342.95999)",
    id: "path1254"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 256.80208,412.95834 -2.72396,-2.71875 0.64063,-0.80209 2.88021,2.88021 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1255"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 257.76042,441.76042 -2.71875,2.71875 -0.80209,-0.79687 2.71875,-2.72396 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1256"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 257.76042,422.23959 -2.71875,2.88021 -0.80209,-0.80209 2.71875,-2.88021 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1257"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 256.95833,456.47917 -2.88021,-2.71875 0.80209,-0.80208 2.88021,2.88021 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1258"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.001862,-6.04667e-4 V 65.92127 M 19.199779,39.520229 v 5.28125 m 0,16.15625 v -5.4375 M 16.481029,9.442104 v 4.317708 M 8.001862,18.07752 h 4.15625 m 4.322917,8.484375 v -4.322916 m -8,28 h 5.28125",
    transform: "matrix(0.75,0,0,0.75,196.44001,299.51999)",
    id: "path1259"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00104767,0.00186733 1.761464,-0.159591 l 1.760417,-0.640625 1.4375,-0.802083 1.28125,-1.276042 1.119792,-1.442708 0.640625,-1.598959 0.479166,-1.598958 v -1.921875 l -0.479166,-1.598958 -0.640625,-1.760417 -1.119792,-1.28125 -1.28125,-1.276042 -1.4375,-0.802083 -1.760417,-0.640625 -1.76041633,-0.161458 -1.76041667,0.161458 -1.760417,0.640625 -1.442708,0.802083 -1.276042,1.276042 -1.119791,1.28125 -0.640625,1.760417 -0.479167,1.598958 v 1.921875 l 0.479167,1.598958 0.640625,1.598959 1.119791,1.442708 1.276042,1.276042 1.442708,0.802083 1.760417,0.640625 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,208.8,319.44001)",
    id: "path1260"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 287.04167,417.4375 h -4.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1261"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 251.35937,400.95834 v 64.32291 -65.92187 65.92187",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1262"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -2.03333e-4,8.18667e-4 2.077922,-0.16064 4.161255,-0.801265 6.077922,-1.59814 l 1.604166,-1.28125 1.4375,-1.442708 1.28125,-1.760417 0.796875,-1.755208 0.640625,-2.083333 0.161459,-2.078125 -0.161459,-2.083334 -0.640625,-2.078125 -0.796875,-1.921875 -1.28125,-1.598958 -1.4375,-1.4375 -1.604166,-1.28125 -1.916667,-0.802083 -2.083333,-0.635417 -2.078125333,-0.161458 -2.078124667,0.161458 -2.083334,0.635417 -1.760416,0.802083 -1.760417,1.28125 -1.4375,1.4375 -1.28125,1.598958 -0.796875,1.921875 -0.640625,2.078125 -0.161458,2.083334 0.161458,2.078125 0.640625,2.083333 0.796875,1.755208 1.28125,1.760417 1.4375,1.442708 1.760417,1.28125 1.760416,0.796875 2.083334,0.640625 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,210.84,395.64001)",
    id: "path1263"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 291.83854,515.52084 h -5.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1264"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -2.03333e-4,-0.00188667 1.921672,-0.158137 l 1.916666,-0.484375 1.760417,-0.958333 1.442708,-1.119792 1.4375,-1.4375 0.963542,-1.760416 0.635417,-1.760417 0.484375,-1.921875 v -1.916667 l -0.484375,-1.921875 -0.635417,-1.760416 -0.963542,-1.760417 -1.4375,-1.4375 -1.442708,-1.119792 -1.760417,-0.963541 -1.916666,-0.479167 -1.921875333,-0.161458 -1.921874667,0.161458 -1.916667,0.479167 -1.760417,0.963541 -1.442708,1.119792 -1.4375,1.4375 -0.958333,1.760417 -0.640625,1.760416 -0.479167,1.921875 v 1.916667 l 0.479167,1.921875 0.640625,1.760417 0.958333,1.760416 1.4375,1.4375 1.442708,1.119792 1.760417,0.958333 1.916667,0.484375 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,210.84,394.56001)",
    id: "path1265"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 251.35937,465.28125 h 79.04167 m -79.04167,65.91667 h 79.04167 m -79.04167,-65.91667 h 79.04167",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1266"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -4.06667e-4,0.00122633 1.921468,-0.160232 l 1.760417,-0.640625 1.760417,-0.796875 1.4375,-1.28125 1.28125,-1.442708 0.796875,-1.760417 0.640625,-1.760417 0.161458,-1.916666 -0.161458,-1.921875 -0.640625,-1.760417 -0.796875,-1.760417 -1.28125,-1.4375 -1.4375,-1.28125 -1.760417,-0.796875 -1.760417,-0.640625 -1.921874667,-0.161458 -1.921875333,0.161458 -1.755208,0.640625 -1.760417,0.796875 -1.442708,1.28125 -1.28125,1.4375 -0.796875,1.760417 -0.640625,1.760417 -0.161458,1.921875 0.161458,1.916666 0.640625,1.760417 0.796875,1.760417 1.28125,1.442708 1.442708,1.28125 1.760417,0.796875 1.755208,0.640625 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,235.67999,393.96002)",
    id: "path1267"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 8.44333e-4,-6.04667e-4 2.078969,-0.162063 4.162303,-0.79748 l 1.916666,-0.802083 1.598959,-1.28125 1.442708,-1.4375 1.28125,-1.760417 0.796875,-1.760416 0.640625,-2.083334 0.161458,-2.078125 -0.161458,-2.078125 -0.640625,-2.083333 -0.796875,-1.916667 -1.28125,-1.598958 -1.442708,-1.442708 -1.598959,-1.28125 -1.916666,-0.796875 -2.083334,-0.640625 -2.078124667,-0.161459 -2.083333333,0.161459 -2.078125,0.640625 -1.760417,0.796875 -1.760416,1.28125 -1.4375,1.442708 -1.28125,1.598958 -0.802084,1.916667 -0.635416,2.083333 -0.161459,2.078125 0.161459,2.078125 0.635416,2.083334 0.802084,1.760416 1.28125,1.760417 1.4375,1.4375 1.760416,1.28125 1.760417,0.802083 2.078125,0.635417 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,233.63999,371.51999)",
    id: "path1268"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.001251,8.18667e-4 H -4.318959 M -0.480418,-32.16064 h -5.4375 m -2.5625,40.640625 V 4.318527 m -2.71875,-25.760417 v -5.4375 m 0,-16 v 5.28125",
    transform: "matrix(0.75,0,0,0.75,242.04,386.64001)",
    id: "path1269"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -4.06667e-4,5.33333e-6 1.76001,-0.161453 l 1.760417,-0.640625 1.4375,-0.796875 1.28125,-1.28125 1.119791,-1.4375 0.640625,-1.604167 0.479167,-1.598958 v -1.916667 l -0.479167,-1.604166 -0.640625,-1.760417 -1.119791,-1.276042 -1.28125,-1.28125 -1.4375,-0.802083 -1.760417,-0.640625 -1.760416667,-0.15625 -1.760416333,0.15625 -1.760417,0.640625 -1.4375,0.802083 -1.28125,1.28125 -1.119792,1.276042 -0.640625,1.760417 -0.479166,1.604166 v 1.916667 l 0.479166,1.598958 0.640625,1.604167 1.119792,1.4375 1.28125,1.28125 1.4375,0.796875 1.760417,0.640625 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,235.67999,393)",
    id: "path1270"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 305.59896,515.52084 h 4.32291 m 4.31771,-8.64063 v 4.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1271"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 8.44333e-4,0.00186733 1.917511,-0.159591 l 1.921875,-0.479167 1.760417,-0.963541 1.442708,-1.119792 1.4375,-1.4375 0.958333,-1.760417 0.640625,-1.760416 0.479167,-1.921875 v -1.916667 l -0.479167,-1.921875 -0.640625,-1.760417 -0.958333,-1.760416 -1.4375,-1.4375 -1.442708,-1.119792 -1.760417,-0.963542 -1.921875,-0.479166 -1.916666667,-0.15625 -1.921875333,0.15625 -1.916666,0.479166 -1.760417,0.963542 -1.442708,1.119792 -1.4375,1.4375 -0.963542,1.760416 -0.640625,1.760417 -0.479167,1.921875 v 1.916667 l 0.479167,1.921875 0.640625,1.760416 0.963542,1.760417 1.4375,1.4375 1.442708,1.119792 1.760417,0.963541 1.916666,0.479167 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,233.63999,370.44001)",
    id: "path1272"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 300.80208,483.35938 h 5.27604 m 24.32292,47.83854 v -65.91667",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1273"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 0.00104767,-1.98e-4 1.91666633,-0.161458 1.760417,-0.640625 1.760417,-0.796875 1.442708,-1.28125 1.28125,-1.4375 0.796875,-1.760417 0.640625,-1.760417 0.161458,-1.921875 -0.161458,-1.921875 -0.640625,-1.755208 -0.796875,-1.760417 -1.28125,-1.442708 -1.442708,-1.28125 -1.760417,-0.796875 -1.760417,-0.640625 -1.91666633,-0.161458 -1.92187467,0.161458 -1.760417,0.640625 -1.760417,0.796875 -1.4375,1.28125 -1.28125,1.442708 -0.802083,1.760417 -0.635417,1.755208 -0.161458,1.921875 0.161458,1.921875 0.635417,1.760417 0.802083,1.760417 1.28125,1.4375 1.4375,1.28125 1.760417,0.796875 1.760417,0.640625 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,208.8,369.83999)",
    id: "path1274"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,-0.001449 0.800629,-0.157699 1.597504,-0.642074 2.238129,-1.277491 2.561046,-2.079574 V -3.037907 L 2.238129,-3.839991 1.597504,-4.480616 0.800629,-4.959782 -0.00145433,-5.121241 -0.798329,-4.959782 l -0.802084,0.479166 -0.640625,0.640625 -0.317708,0.802084 v 0.958333 l 0.317708,0.802083 0.640625,0.635417 0.802084,0.484375 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,191.88,368.87999)",
    id: "path1275"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,-0.001449 0.800629,-0.157699 1.597504,-0.642074 2.238129,-1.277491 2.561046,-2.079574 V -3.037907 L 2.238129,-3.839991 1.597504,-4.480616 0.800629,-4.959782 -0.00145433,-5.121241 -0.798329,-4.959782 l -0.802084,0.479166 -0.640625,0.640625 -0.317708,0.802084 v 0.958333 l 0.317708,0.802083 0.640625,0.635417 0.802084,0.484375 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,191.88,359.87999)",
    id: "path1276"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,-0.00209 0.800629,-0.15834 1.597504,-0.637507 2.238129,-1.278132 2.561046,-2.080215 V -3.038548 L 2.238129,-3.840632 1.597504,-4.481257 0.800629,-4.960423 -0.00145433,-5.121882 -0.798329,-4.960423 l -0.802084,0.479166 -0.640625,0.640625 -0.317708,0.802084 v 0.958333 l 0.317708,0.802083 0.640625,0.640625 0.802084,0.479167 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,191.88,383.40001)",
    id: "path1277"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,-0.00209 0.800629,-0.15834 1.597504,-0.637507 2.238129,-1.278132 2.561046,-2.080215 V -3.038548 L 2.238129,-3.840632 1.597504,-4.481257 0.800629,-4.960423 -0.00145433,-5.121882 -0.798329,-4.960423 l -0.802084,0.479166 -0.640625,0.640625 -0.317708,0.802084 v 0.958333 l 0.317708,0.802083 0.640625,0.640625 0.802084,0.479167 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,191.88,392.40001)",
    id: "path1278"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 256.80208,479.04167 -2.72396,-2.88021 0.64063,-0.80208 2.88021,2.88021 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1279"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 257.76042,507.6823 -2.71875,2.71875 -0.80209,-0.64063 2.71875,-2.88021 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1280"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 257.76042,488.16146 -2.71875,2.88021 -0.80209,-0.80208 2.71875,-2.71875 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1281"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 256.95833,522.5625 -2.88021,-2.8802 0.80209,-0.80209 2.88021,2.88021 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1282"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.001862,0.00125633 V 65.917923 M 19.199779,39.52209 v 5.276041 m 0,16.161459 v -5.4375 M 16.481029,9.438756 v 4.322917 m -8.479167,4.317708 h 4.15625 m 4.322917,8.479167 v -4.15625 m -8,27.838542 h 5.28125",
    transform: "matrix(0.75,0,0,0.75,196.44001,348.95999)",
    id: "path1283"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 0.00104767,-0.001449 1.76041633,-0.15625 1.760417,-0.640625 1.4375,-0.802083 1.28125,-1.28125 1.119792,-1.4375 0.640625,-1.598959 0.479166,-1.604166 v -1.916667 l -0.479166,-1.598958 -0.640625,-1.760417 -1.119792,-1.28125 -1.28125,-1.28125 -1.4375,-0.796875 -1.760417,-0.640625 -1.76041633,-0.161458 -1.76041667,0.161458 -1.760417,0.640625 -1.442708,0.796875 -1.276042,1.28125 -1.119791,1.28125 -0.640625,1.760417 -0.479167,1.598958 v 1.916667 l 0.479167,1.604166 0.640625,1.598959 1.119791,1.4375 1.276042,1.28125 1.442708,0.802083 1.760417,0.640625 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,208.8,368.87999)",
    id: "path1284"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 287.04167,483.35938 h -4.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1285"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 251.35937,466.88021 v 64.31771 -65.91667 65.91667",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1286"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -2.03333e-4,-0.00249667 2.077922,-0.158747 l 2.083333,-0.640625 1.916667,-0.802083 1.604166,-1.276042 1.4375,-1.442708 1.28125,-1.760417 0.796875,-1.760416 0.640625,-2.078125 0.161459,-2.083334 -0.161459,-2.078125 -0.640625,-2.078125 -0.796875,-1.921875 -1.28125,-1.598958 -1.4375,-1.442708 -1.604166,-1.276042 -1.916667,-0.802083 -2.083333,-0.640625 -2.078125333,-0.161459 -2.078124667,0.161459 -2.083334,0.640625 -1.760416,0.802083 -1.760417,1.276042 -1.4375,1.442708 -1.28125,1.598958 -0.796875,1.921875 -0.640625,2.078125 -0.161458,2.078125 0.161458,2.083334 0.640625,2.078125 0.796875,1.760416 1.28125,1.760417 1.4375,1.442708 1.760417,1.276042 1.760416,0.802083 2.083334,0.640625 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,210.84,445.08)",
    id: "path1287"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 291.83854,581.4375 h -5.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1288"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -2.03333e-4,5.33333e-6 1.921672,-0.161453 3.838338,-0.64062 l 1.760417,-0.958333 1.442708,-1.119792 1.4375,-1.442708 0.963542,-1.760417 0.635417,-1.760416 0.484375,-1.916667 v -1.921875 l -0.484375,-1.916667 -0.635417,-1.760416 -0.963542,-1.760417 -1.4375,-1.442708 -1.442708,-1.119792 -1.760417,-0.958333 -1.916666,-0.479167 -1.921875333,-0.161458 -1.921874667,0.161458 -1.916667,0.479167 -1.760417,0.958333 -1.442708,1.119792 -1.4375,1.442708 -0.958333,1.760417 -0.640625,1.760416 -0.479167,1.916667 v 1.921875 l 0.479167,1.916667 0.640625,1.760416 0.958333,1.760417 1.4375,1.442708 1.442708,1.119792 1.760417,0.958333 1.916667,0.479167 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,210.84,444)",
    id: "path1289"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 251.35937,531.19792 h 79.04167 m -79.04167,65.92188 h 79.04167 m -79.04167,-65.92188 h 79.04167",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1290"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -4.06667e-4,-0.00209 1.921468,-0.15834 l 1.760417,-0.640625 1.760417,-0.802083 1.4375,-1.28125 1.28125,-1.4375 0.796875,-1.760417 0.640625,-1.760417 0.161458,-1.921875 -0.161458,-1.916666 -0.640625,-1.760417 -0.796875,-1.760417 -1.28125,-1.4375 -1.4375,-1.28125 -1.760417,-0.802083 -1.760417,-0.640625 -1.921874667,-0.15625 -1.921875333,0.15625 -1.755208,0.640625 -1.760417,0.802083 -1.442708,1.28125 -1.28125,1.4375 -0.796875,1.760417 -0.640625,1.760417 -0.161458,1.916666 0.161458,1.921875 0.640625,1.760417 0.796875,1.760417 1.28125,1.4375 1.442708,1.28125 1.760417,0.802083 1.755208,0.640625 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,235.67999,443.40001)",
    id: "path1291"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 8.44333e-4,0.00122633 2.078969,-0.160232 l 2.083334,-0.640625 1.916666,-0.796875 1.598959,-1.28125 1.442708,-1.442708 1.28125,-1.760417 0.796875,-1.760417 0.640625,-2.078125 0.161458,-2.078125 -0.161458,-2.083333 -0.640625,-2.078125 -0.796875,-1.921875 -1.28125,-1.598958 -1.442708,-1.4375 -1.598959,-1.28125 -1.916666,-0.802084 -2.083334,-0.640625 -2.078124667,-0.15625 -2.083333333,0.15625 -2.078125,0.640625 -1.760417,0.802084 -1.760416,1.28125 -1.4375,1.4375 -1.28125,1.598958 -0.802084,1.921875 -0.635416,2.078125 -0.161459,2.083333 0.161459,2.078125 0.635416,2.078125 0.802084,1.760417 1.28125,1.760417 1.4375,1.442708 1.760416,1.28125 1.760417,0.796875 2.078125,0.640625 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,233.63999,420.96002)",
    id: "path1292"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.001251,-0.00249667 H -4.318959 M -0.480418,-32.158747 h -5.4375 m -2.5625,40.640625 V 4.32042 m -2.71875,-25.760417 v -5.4375 m 0,-16 v 5.276042",
    transform: "matrix(0.75,0,0,0.75,242.04,436.08)",
    id: "path1293"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -4.06667e-4,0.00189733 1.76001,-0.159561 l 1.760417,-0.640625 1.4375,-0.802083 1.28125,-1.276042 1.119791,-1.442708 0.640625,-1.598959 0.479167,-1.598958 v -1.921875 l -0.479167,-1.598958 -0.640625,-1.760417 -1.119791,-1.28125 -1.28125,-1.276042 -1.4375,-0.802083 -1.760417,-0.640625 -1.760416667,-0.161458 -1.760416333,0.161458 -1.760417,0.640625 -1.4375,0.802083 -1.28125,1.276042 -1.119792,1.28125 -0.640625,1.760417 -0.479166,1.598958 v 1.921875 l 0.479166,1.598958 0.640625,1.598959 1.119792,1.442708 1.28125,1.276042 1.4375,0.802083 1.760417,0.640625 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,235.67999,442.43998)",
    id: "path1294"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 305.59896,581.4375 h 4.32291 m 4.31771,-8.63541 v 4.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1295"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 8.44333e-4,-0.00148 1.917511,-0.15773 3.839386,-0.642105 5.599803,-1.600438 7.042511,-2.72023 l 1.4375,-1.4375 0.958333,-1.760417 0.640625,-1.760416 0.479167,-1.921875 v -1.921875 l -0.479167,-1.916667 -0.640625,-1.760417 -0.958333,-1.760416 -1.4375,-1.442709 -1.442708,-1.119791 -1.760417,-0.958334 -1.921875,-0.479166 -1.916666667,-0.161459 -1.921875333,0.161459 -1.916666,0.479166 -1.760417,0.958334 -1.442708,1.119791 -1.4375,1.442709 -0.963542,1.760416 -0.640625,1.760417 -0.479167,1.916667 v 1.921875 l 0.479167,1.921875 0.640625,1.760416 0.963542,1.760417 1.4375,1.4375 1.442708,1.119792 1.760417,0.958333 1.916666,0.484375 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,233.63999,419.88002)",
    id: "path1296"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 300.80208,549.28125 h 5.27604 m 24.32292,47.83855 v -65.92188",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1297"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 0.00104767,0.001694 1.91666633,-0.161458 1.760417,-0.640625 1.760417,-0.802084 1.442708,-1.276041 1.28125,-1.442709 0.796875,-1.760416 0.640625,-1.760417 0.161458,-1.916667 -0.161458,-1.921875 -0.640625,-1.760416 -0.796875,-1.760417 -1.28125,-1.4375 -1.442708,-1.28125 -1.760417,-0.802083 -1.760417,-0.635417 -1.91666633,-0.161458 -1.92187467,0.161458 -1.760417,0.635417 -1.760417,0.802083 -1.4375,1.28125 -1.28125,1.4375 -0.802083,1.760417 -0.635417,1.760416 -0.161458,1.921875 0.161458,1.916667 0.635417,1.760417 0.802083,1.760416 1.28125,1.442709 1.4375,1.276041 1.760417,0.802084 1.760417,0.640625 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,208.8,419.27998)",
    id: "path1298"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,4.12e-4 0.800629,-0.161046 1.597504,-0.640213 2.238129,-1.280838 2.561046,-2.077713 V -3.041255 L 2.238129,-3.83813 1.597504,-4.478755 0.800629,-4.957921 -0.00145433,-5.11938 -0.798329,-4.957921 l -0.802084,0.479166 -0.640625,0.640625 -0.317708,0.796875 v 0.963542 l 0.317708,0.796875 0.640625,0.640625 0.802084,0.479167 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,191.88,418.32)",
    id: "path1299"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,4.12e-4 0.800629,-0.161046 1.597504,-0.640213 2.238129,-1.280838 2.561046,-2.077713 V -3.041255 L 2.238129,-3.83813 1.597504,-4.478755 0.800629,-4.957921 -0.00145433,-5.11938 -0.798329,-4.957921 l -0.802084,0.479166 -0.640625,0.640625 -0.317708,0.796875 v 0.963542 l 0.317708,0.796875 0.640625,0.640625 0.802084,0.479167 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,191.88,409.32)",
    id: "path1300"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,-1.98e-4 0.800629,-0.161656 1.597504,-0.640823 2.238129,-1.281448 2.561046,-2.078323 V -3.041865 L 2.238129,-3.83874 1.597504,-4.479365 0.800629,-4.958531 -0.00145433,-5.11999 -0.798329,-4.958531 l -0.802084,0.479166 -0.640625,0.640625 -0.317708,0.796875 v 0.963542 l 0.317708,0.796875 0.640625,0.640625 0.802084,0.479167 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,191.88,432.83999)",
    id: "path1301"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,-1.98e-4 0.800629,-0.161656 1.597504,-0.640823 2.238129,-1.281448 2.561046,-2.078323 V -3.041865 L 2.238129,-3.83874 1.597504,-4.479365 0.800629,-4.958531 -0.00145433,-5.11999 -0.798329,-4.958531 l -0.802084,0.479166 -0.640625,0.640625 -0.317708,0.796875 v 0.963542 l 0.317708,0.796875 0.640625,0.640625 0.802084,0.479167 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,191.88,441.83999)",
    id: "path1302"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 256.80208,544.95834 -2.72396,-2.88021 0.64063,-0.64063 2.88021,2.72396 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1303"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 257.76042,573.59896 -2.71875,2.71875 -0.80209,-0.63541 2.71875,-2.88021 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1304"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 257.76042,554.07813 -2.71875,2.88021 -0.80209,-0.79688 2.71875,-2.72396 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1305"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 256.95833,588.47917 -2.88021,-2.88021 0.80209,-0.64062 2.88021,2.72396 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1306"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.001862,-0.00209 V 65.919785 M 19.199779,39.518743 v 5.28125 m 0,16.161459 V 55.518743 M 16.481029,9.440618 v 4.317709 m -8.479167,4.322916 h 4.15625 m 4.322917,8.479167 v -4.161458 m -8,27.838541 h 5.28125",
    transform: "matrix(0.75,0,0,0.75,196.44001,398.40001)",
    id: "path1307"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 0.00104767,4.12e-4 1.76041633,-0.161458 1.760417,-0.640625 1.4375,-0.796875 1.28125,-1.28125 1.119792,-1.442709 0.640625,-1.598958 0.479166,-1.598958 v -1.921875 l -0.479166,-1.598959 -0.640625,-1.760416 -1.119792,-1.276042 -1.28125,-1.28125 -1.4375,-0.802083 -1.760417,-0.640625 -1.76041633,-0.15625 -1.76041667,0.15625 -1.760417,0.640625 -1.442708,0.802083 -1.276042,1.28125 -1.119791,1.276042 -0.640625,1.760416 -0.479167,1.598959 v 1.921875 l 0.479167,1.598958 0.640625,1.598958 1.119791,1.442709 1.276042,1.28125 1.442708,0.796875 1.760417,0.640625 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,208.8,418.32)",
    id: "path1308"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 287.04167,549.28125 h -4.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1309"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 251.35937,532.80209 V 597.1198 531.19792 597.1198",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1310"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 128.95833,408.47917 v 96.32292 H 44.640625 v -96.32292 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1311"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.001251,0.00210067 H -17.600209 M -4.318959,-7.680191 -13.282501,7.679184 m 0,-15.359375 8.963542,15.359375 M -17.600209,0.00210067 H -0.001251 M -13.282501,7.679184 -4.318959,-7.680191 m 0,15.359375 -8.963542,-15.359375",
    transform: "matrix(0.75,0,0,0.75,71.040001,342.59999)",
    id: "path1312"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 258.71875,939.35938 V 794.71875 h 72.64062 v 144.64063 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1313"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 266.71875,870.23959 -1.11979,0.16146 -1.11979,0.47916 -0.95834,0.64063 -0.64062,0.95833 -0.47917,1.11979 -0.16146,1.11979",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1314"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 266.71875,870.07813 h 43.52083",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1315"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 314.71875,874.71875 -0.15625,-1.11979 -0.48438,-1.11979 -0.64062,-0.95833 -0.95833,-0.64063 -1.1198,-0.47916 -1.11979,-0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1316"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 314.88021,874.71875 v 56.80209",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1317"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 310.23958,936 1.11979,-0.16145 1.1198,-0.47917 0.95833,-0.64063 0.64062,-0.95833 0.48438,-1.11979 0.15625,-1.11979",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1318"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 310.23958,936 H 266.71875",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1319"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 262.23958,931.52084 0.16146,1.11979 0.47917,1.11979 0.64062,0.95833 0.95834,0.64063 1.11979,0.47917 1.11979,0.16145",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1320"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 262.07812,931.52084 V 874.71875",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1321"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00209533,-8.08e-4 -1.439595,0.16065 -2.882304,0.639817 -4.158345,1.4419 l -0.963542,0.958334 -0.796875,1.28125 -0.479167,1.4375 -0.161458,1.442708 0.161458,1.4375 0.479167,1.442708 0.796875,1.276042 0.963542,0.963542 1.276041,0.796875 1.442709,0.479166 1.43749967,0.161459 1.44270833,-0.161459 1.4375,-0.479166 1.28125,-0.796875 L 5.117696,10.717942 5.91978,9.4419 6.398946,7.999192 6.560405,6.561692 6.398946,5.118984 5.91978,3.681484 5.117696,2.400234 4.159363,1.4419 2.878113,0.639817 1.440613,0.16065 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,218.40001,672.35998)",
    id: "path1322"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 286.5625,907.83855 9.27604,-9.4375 m 0,9.4375 -9.27604,-9.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1323"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m -6.1e-4,-0.00148 -0.958333,0.161458 -0.963542,0.479167 -0.635417,0.640625 -0.484375,0.958333 -0.15625,0.963542 0.15625,0.958333 0.484375,0.958334 0.635417,0.640625 0.963542,0.479166 L -6.1e-4,6.399562 0.957723,6.238103 1.921265,5.758937 2.56189,5.118312 3.041057,4.159978 3.202515,3.201645 3.041057,2.238103 2.56189,1.27977 1.921265,0.639145 0.957723,0.159978 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,242.51999,674.88002)",
    id: "path1324"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 266.71875,797.76042 -1.11979,0.16146 -1.11979,0.47917 -0.95834,0.64062 -0.64062,0.95833 -0.47917,1.1198 -0.16146,1.11979",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1325"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 266.71875,797.59896 h 43.52083",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1326"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 314.71875,802.23959 314.5625,801.1198 314.07812,800 l -0.64062,-0.95833 -0.95833,-0.64062 -1.1198,-0.47917 -1.11979,-0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1327"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 314.88021,802.23959 v 56.64062",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1328"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 310.23958,863.35938 1.11979,-0.16146 1.1198,-0.47917 0.95833,-0.64062 0.64062,-0.95833 0.48438,-1.1198 0.15625,-1.11979",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1329"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 310.23958,863.52084 H 266.71875",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1330"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 262.23958,858.88021 0.16146,1.11979 0.47917,1.1198 0.64062,0.95833 0.95834,0.64062 1.11979,0.47917 1.11979,0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1331"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 262.07812,858.88021 V 802.23959",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1332"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00209533,5.33333e-6 -1.439595,0.161464 -2.882304,0.64063 l -1.276041,0.796875 -0.963542,0.963542 -0.796875,1.28125 -0.479167,1.4375 -0.161458,1.442708 0.161458,1.4375 0.479167,1.4375 0.796875,1.28125 0.963542,0.963542 1.276041,0.796875 1.442709,0.479167 1.43749967,0.161458 1.44270833,-0.161458 1.4375,-0.479167 1.28125,-0.796875 0.958333,-0.963542 0.802084,-1.28125 0.479166,-1.4375 0.161459,-1.4375 L 6.398946,5.119797 5.91978,3.682297 5.117696,2.401047 4.159363,1.437505 2.878113,0.64063 1.440613,0.161464 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,218.40001,618)",
    id: "path1333"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 286.5625,835.19792 9.27604,-9.27604 m 0,9.27604 -9.27604,-9.27604",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1334"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -6.1e-4,-6.04667e-4 -0.958943,0.160854 -1.922485,0.64002 l -0.635417,0.640625 -0.484375,0.958334 -0.15625,0.963541 0.15625,0.958334 0.484375,0.958333 0.635417,0.640625 0.963542,0.479167 L -6.1e-4,6.400437 0.957723,6.238979 1.921265,5.759812 2.56189,5.119187 3.041057,4.160854 3.202515,3.20252 3.041057,2.238979 2.56189,1.280645 1.921265,0.64002 0.957723,0.160854 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,242.51999,620.51999)",
    id: "path1335"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 331.35937,596.80209 V 794.71875 H 245.59896 V 596.80209 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1336"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 130.23958,504.80209 V 702.71875 H 44.640625 V 504.80209 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1337"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 130.23958,702.71875 V 900.47917 H 44.640625 V 702.71875 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1338"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 331.04167,200.80209 V 398.71875 H 245.28125 V 200.80209 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1339"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 97.28125,408.47917 H 44.640625 V 342.5625 H 97.28125 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1340"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 97.28125,342.5625 H 44.640625 V 276.64063 H 97.28125 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1341"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 183.19792,336.80209 v 158.23958 h -9.91667 V 336.80209 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1342"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00208033,0.00210067 -0.798955,-0.961441 -1.601039,-1.758316 -2.72083,-2.237483 l -1.119792,-0.322916 -1.119792,-0.161459 -1.119791,0.161459 -1.119792,0.322916 -1.119792,0.479167 -0.802083,0.796875 -0.796875,0.96354167",
    transform: "matrix(0.75,0,0,0.75,137.4,252.59999)",
    id: "path1343"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.001251,2.08667e-4 0.798126,0.958542 1.600209,1.760625 2.720001,2.239792 3.839793,2.5575 4.959584,2.718959 6.079376,2.5575 7.199168,2.239792 8.318959,1.760625 9.121043,0.958542 9.917918,2.08667e-4",
    transform: "matrix(0.75,0,0,0.75,129.96,371.16)",
    id: "path1344"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 178.23958,336.80209 V 495.04167",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1345"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g1345"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-0",
    x: 139.43977,
    y: 289.4371,
    id: "use1345"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 8929.9274,-4348.8195 c 8.779,3.7963 13.2872,13.1685 13.2872,27.9979 0,3.7964 -0.7119,7.83 -1.8982,11.8636 l -5.6945,21.3544 c -6.0504,23.4898 -18.3885,39.1497 -37.0143,46.9796 -9.2535,3.7963 -19.8121,5.6945 -31.7943,5.6945 h -40.8106 c -6.9995,0 -10.4399,-3.4404 -10.4399,-10.4399 0,-7.2368 3.4404,-10.9145 10.4399,-10.9145 h 46.5051 c 9.135,0 17.6767,-2.9659 25.6253,-9.0163 8.1858,-5.9317 13.4058,-13.4058 15.6599,-22.3034 l 5.6945,-21.3544 c 1.1863,-4.3895 1.8981,-8.3045 1.8981,-11.8636 0,-13.2871 -8.779,-19.9307 -26.0998,-19.9307 h -18.9816 c -7.3554,0 -10.9145,-3.4404 -10.9145,-10.4399 0,-6.8809 3.5591,-10.44 10.9145,-10.44 h 24.6761 c 12.5754,0 23.4899,-5.2199 32.7434,-15.6598 4.3895,-4.9827 7.2368,-10.44 8.5418,-16.1345 0.9491,-3.4404 1.4236,-6.6435 1.4236,-9.4908 0,-14.8294 -8.5418,-22.3035 -25.6253,-22.3035 h -41.2851 c -6.9995,0 -10.4399,-3.4404 -10.4399,-10.4399 0,-6.8808 3.4404,-10.4399 10.4399,-10.4399 h 46.9796 c 16.3717,0 28.4725,7.474 36.0652,22.3035 3.4404,6.4063 5.22,13.1685 5.22,20.4053 0,3.559 -0.3559,6.8808 -0.9491,9.9653 -6.0504,23.134 -17.4394,37.9634 -34.167,44.607 z m 0,0",
    transform: "matrix(0,0.0329265,-0.0329265,0,0,-4e-6)",
    id: "path1346"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g1346"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-1",
    x: 139.43977,
    y: 294.39426,
    id: "use1346"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 9023.0562,-4256.2839 c 21.8289,0 35.5906,-10.4399 41.2851,-31.3197 l 5.6945,-21.3544 c 1.1864,-4.0336 1.8982,-8.0672 1.8982,-11.8636 0,-13.2871 -8.8976,-19.9307 -26.5743,-19.9307 h -32.7434 l -13.7617,53.1487 c -0.9491,3.2031 -1.4236,5.6945 -1.4236,7.5926 0,7.3554 2.3727,13.1686 7.1181,17.5581 4.9827,4.1522 11.1517,6.169 18.5071,6.169 z m -5.6945,21.3544 c -14.9481,0 -26.8116,-7.7113 -35.5906,-23.2525 -4.1523,-6.6436 -6.1691,-13.5245 -6.1691,-20.8799 0,-2.8472 0.4746,-5.6945 1.4237,-8.5417 l 17.0835,-63.5886 c 5.9317,-23.3712 16.3717,-42.9461 31.3197,-58.8432 16.7276,-17.6767 38.4379,-29.5402 65.0122,-35.5907 0.5932,-0.2372 1.4237,-0.4745 2.3728,-0.4745 7.2367,0 10.9144,3.5591 10.9144,10.4399 0,6.0504 -2.3727,9.3722 -7.1181,9.9654 -11.7449,1.6609 -23.6085,6.0504 -35.5906,13.2872 -21.5917,13.0499 -35.3534,29.8961 -41.2852,50.7759 h 31.7943 c 11.9822,0 21.9476,4.0336 29.8961,11.8636 7.83,7.5927 11.8636,17.4394 11.8636,29.4216 0,4.1522 -0.4745,7.9486 -1.4236,11.389 l -5.6945,21.3544 c -6.6436,24.6761 -18.5072,40.5733 -35.5907,47.4541 -8.8976,3.5591 -19.9307,5.22 -33.2179,5.22 z m 0,0",
    transform: "matrix(0,0.0329265,-0.0329265,0,0,-4e-6)",
    id: "path1347"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g1347"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-2",
    x: 139.43977,
    y: 299.25421,
    id: "use1347"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 9238.0236,-4338.8542 -61.2159,99.1793 c -1.8981,3.2031 -4.9826,4.7454 -9.0162,4.7454 -2.8473,0 -5.4573,-1.0677 -7.5927,-3.3218 -1.8982,-2.1354 -2.8473,-4.7454 -2.8473,-7.5927 l 7.1182,-189.8167 c 0,-6.8808 3.4404,-10.4399 10.4399,-10.4399 7.5926,0 11.1517,3.6777 10.9144,10.9145 l -6.169,150.4297 56.945,-93.0102 c 1.8982,-3.4404 4.7454,-5.2199 8.5418,-5.2199 6.8808,0 10.5585,3.3218 10.9144,9.9653 l 7.1181,89.6884 77.3504,-157.0733 c 1.8981,-3.7963 4.9827,-5.6945 9.4908,-5.6945 6.8809,0 10.4399,3.5591 10.4399,10.4399 0,1.6609 -0.3559,3.2032 -0.9491,4.7454 l -94.4338,190.2913 c -1.8982,3.7963 -4.9827,5.6945 -9.0163,5.6945 -6.9995,0 -10.6772,-3.3218 -10.9144,-9.9654 z m 0,0",
    transform: "matrix(0,0.0329265,-0.0329265,0,0,-4e-6)",
    id: "path1348"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g1348"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-3",
    x: 139.56094,
    y: 313.67627,
    id: "use1348"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 9649.4514,-4259.9616 c 7.2367,0 10.9144,3.6777 10.9144,10.9145 0,6.9995 -3.6777,10.4399 -10.9144,10.4399 h -90.163 c -3.2031,0 -5.5758,-0.9491 -7.1181,-2.8473 -1.6609,-2.1354 -1.8982,-4.7454 -0.9491,-7.5926 l 51.7251,-192.664 c 1.5422,-5.3386 4.864,-8.0672 9.9653,-8.0672 7.2368,0 10.9145,3.5591 10.9145,10.4399 0,1.305 -0.2373,2.2541 -0.4745,2.8473 l -47.4542,176.5295 z m 0,0",
    transform: "matrix(0,0.0329265,-0.0329265,0,0,-4e-6)",
    id: "path1349"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g1349"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-4",
    x: 139.56094,
    y: 318.63342,
    id: "use1349"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 9806.6433,-4344.43 h -57.4195 l -22.778,84.4684 h 73.5539 c 7.2368,0 10.9145,3.6777 10.9145,10.9145 0,6.9995 -3.6777,10.4399 -10.9145,10.4399 h -90.1629 c -3.2032,0 -5.5759,-0.9491 -7.1181,-2.8473 -1.6609,-2.1354 -1.8982,-4.7454 -0.9491,-7.5926 l 50.776,-190.2913 c 1.8981,-6.8808 6.6435,-10.4399 14.2362,-10.4399 h 83.9939 c 7.2368,0 10.9145,3.5591 10.9145,10.4399 0,6.9995 -3.6777,10.4399 -10.9145,10.4399 h -78.7739 l -17.0835,63.5886 h 51.725 c 6.8809,0 10.4399,3.5591 10.4399,10.44 0,6.9995 -3.559,10.4399 -10.4399,10.4399 z m 0,0",
    transform: "matrix(0,0.0329265,-0.0329265,0,0,-4e-6)",
    id: "path1350"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g1350"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-5",
    x: 139.56094,
    y: 323.49335,
    id: "use1350"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 9900.1281,-4439.3384 c 1.8981,-6.8808 6.6435,-10.4399 14.2362,-10.4399 h 65.4868 c 11.0331,0 20.6429,4.7454 28.9469,14.2363 8.542,9.2535 12.813,19.3375 12.813,30.3706 0,2.61 -0.475,5.22 -1.424,8.0672 l -27.9978,105.8229 c -9.4909,35.1161 -32.6248,52.6741 -69.2831,52.6741 h -65.4868 c -3.2032,0 -5.5759,-0.9491 -7.1181,-2.8473 -1.6609,-2.1354 -1.8982,-4.7454 -0.9491,-7.5926 z m 19.4562,10.4399 -45.556,168.9369 h 54.5723 c 9.1349,0 17.6766,-2.9659 25.6252,-9.0163 8.1859,-5.9317 13.4058,-13.4058 15.6599,-22.3034 l 28.4725,-105.8229 c 0.5932,-2.8472 0.9491,-5.3386 0.9491,-7.5926 0,-7.2368 -2.3727,-13.0499 -7.1181,-17.5581 -4.7455,-4.3895 -10.7959,-6.6436 -18.0326,-6.6436 z m 0,0",
    transform: "matrix(0,0.0329265,-0.0329265,0,0,-4e-6)",
    id: "path1351"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 195.68229,418.40105 v 23.67708 h -10.08333 v -23.67708 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1352"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 183.19792,740.31771 V 898.5625 h -9.91667 V 740.31771 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1353"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00208033,-8.08e-4 -0.798955,-0.959141 -1.601039,-1.761225 -2.72083,-2.240391 -3.840622,-2.5581 -4.960414,-2.719558 -6.080205,-2.5581 l -1.119792,0.317709 -1.119792,0.479166 -0.802083,0.802084 -0.796875,0.958333",
    transform: "matrix(0.75,0,0,0.75,137.4,555.35998)",
    id: "path1354"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.001251,0.00250733 0.798126,0.960841 1.600209,1.757716 2.720001,2.242091 3.839793,2.559799 4.959584,2.721257 6.079376,2.559799 7.199168,2.242091 8.318959,1.757716 9.121043,0.960841 9.917918,0.00250733",
    transform: "matrix(0.75,0,0,0.75,129.96,673.91999)",
    id: "path1355"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 178.23958,740.31771 V 898.5625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1356"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g1356"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-0",
    x: 139.43977,
    y: 592.19299,
    id: "use1356"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 18124.768,-4348.8195 c 8.779,3.7963 13.287,13.1685 13.287,27.9979 0,3.7964 -0.712,7.83 -1.898,11.8636 l -5.695,21.3544 c -6.05,23.4898 -18.388,39.1497 -37.014,46.9796 -9.254,3.7963 -19.812,5.6945 -31.794,5.6945 h -40.811 c -7,0 -10.44,-3.4404 -10.44,-10.4399 0,-7.2368 3.44,-10.9145 10.44,-10.9145 h 46.505 c 9.135,0 17.677,-2.9659 25.625,-9.0163 8.186,-5.9317 13.406,-13.4058 15.66,-22.3034 l 5.695,-21.3544 c 1.186,-4.3895 1.898,-8.3045 1.898,-11.8636 0,-13.2871 -8.779,-19.9307 -26.1,-19.9307 h -18.982 c -7.355,0 -10.914,-3.4404 -10.914,-10.4399 0,-6.8809 3.559,-10.44 10.914,-10.44 h 24.677 c 12.575,0 23.489,-5.2199 32.743,-15.6598 4.389,-4.9827 7.237,-10.44 8.542,-16.1345 0.949,-3.4404 1.423,-6.6435 1.423,-9.4908 0,-14.8294 -8.541,-22.3035 -25.625,-22.3035 h -41.285 c -7,0 -10.44,-3.4404 -10.44,-10.4399 0,-6.8808 3.44,-10.4399 10.44,-10.4399 h 46.98 c 16.371,0 28.472,7.474 36.065,22.3035 3.44,6.4063 5.22,13.1685 5.22,20.4053 0,3.559 -0.356,6.8808 -0.949,9.9653 -6.051,23.134 -17.44,37.9634 -34.167,44.607 z m 0,0",
    transform: "matrix(0,0.0329265,-0.0329265,0,0,-4e-6)",
    id: "path1357"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g1357"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-1",
    x: 139.43977,
    y: 597.15015,
    id: "use1357"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 18217.896,-4256.2839 c 21.829,0 35.591,-10.4399 41.286,-31.3197 l 5.694,-21.3544 c 1.186,-4.0336 1.898,-8.0672 1.898,-11.8636 0,-13.2871 -8.897,-19.9307 -26.574,-19.9307 h -32.743 l -13.762,53.1487 c -0.949,3.2031 -1.424,5.6945 -1.424,7.5926 0,7.3554 2.373,13.1686 7.118,17.5581 4.983,4.1522 11.152,6.169 18.507,6.169 z m -5.694,21.3544 c -14.948,0 -26.812,-7.7113 -35.591,-23.2525 -4.152,-6.6436 -6.169,-13.5245 -6.169,-20.8799 0,-2.8472 0.475,-5.6945 1.424,-8.5417 l 17.083,-63.5886 c 5.932,-23.3712 16.372,-42.9461 31.32,-58.8432 16.728,-17.6767 38.438,-29.5402 65.012,-35.5907 0.594,-0.2372 1.424,-0.4745 2.373,-0.4745 7.237,0 10.915,3.5591 10.915,10.4399 0,6.0504 -2.373,9.3722 -7.119,9.9654 -11.745,1.6609 -23.608,6.0504 -35.59,13.2872 -21.592,13.0499 -35.354,29.8961 -41.285,50.7759 h 31.794 c 11.982,0 21.947,4.0336 29.896,11.8636 7.83,7.5927 11.864,17.4394 11.864,29.4216 0,4.1522 -0.475,7.9486 -1.424,11.389 l -5.695,21.3544 c -6.643,24.6761 -18.507,40.5733 -35.59,47.4541 -8.898,3.5591 -19.931,5.22 -33.218,5.22 z m 0,0",
    transform: "matrix(0,0.0329265,-0.0329265,0,0,-4e-6)",
    id: "path1358"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g1358"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-2",
    x: 139.43977,
    y: 602.01013,
    id: "use1358"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 18432.982,-4338.8542 -61.215,99.1793 c -1.899,3.2031 -4.983,4.7454 -9.017,4.7454 -2.847,0 -5.457,-1.0677 -7.592,-3.3218 -1.899,-2.1354 -2.848,-4.7454 -2.848,-7.5927 l 7.119,-189.8167 c 0,-6.8808 3.44,-10.4399 10.439,-10.4399 7.593,0 11.152,3.6777 10.915,10.9145 l -6.169,150.4297 56.945,-93.0102 c 1.898,-3.4404 4.745,-5.2199 8.542,-5.2199 6.88,0 10.558,3.3218 10.914,9.9653 l 7.118,89.6884 77.351,-157.0733 c 1.898,-3.7963 4.982,-5.6945 9.49,-5.6945 6.881,0 10.44,3.5591 10.44,10.4399 0,1.6609 -0.356,3.2032 -0.949,4.7454 l -94.434,190.2913 c -1.898,3.7963 -4.982,5.6945 -9.016,5.6945 -6.999,0 -10.677,-3.3218 -10.914,-9.9654 z m 0,0",
    transform: "matrix(0,0.0329265,-0.0329265,0,0,-4e-6)",
    id: "path1359"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g1359"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-3",
    x: 139.56094,
    y: 616.43018,
    id: "use1359"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 18844.292,-4259.9616 c 7.236,0 10.914,3.6777 10.914,10.9145 0,6.9995 -3.678,10.4399 -10.914,10.4399 h -90.163 c -3.204,0 -5.576,-0.9491 -7.118,-2.8473 -1.661,-2.1354 -1.899,-4.7454 -0.95,-7.5926 l 51.725,-192.664 c 1.543,-5.3386 4.865,-8.0672 9.966,-8.0672 7.237,0 10.914,3.5591 10.914,10.4399 0,1.305 -0.237,2.2541 -0.474,2.8473 l -47.454,176.5295 z m 0,0",
    transform: "matrix(0,0.0329265,-0.0329265,0,0,-4e-6)",
    id: "path1360"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g1360"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-4",
    x: 139.56094,
    y: 621.38733,
    id: "use1360"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 19001.484,-4344.43 h -57.42 l -22.778,84.4684 h 73.554 c 7.237,0 10.914,3.6777 10.914,10.9145 0,6.9995 -3.677,10.4399 -10.914,10.4399 h -90.163 c -3.203,0 -5.576,-0.9491 -7.118,-2.8473 -1.661,-2.1354 -1.898,-4.7454 -0.949,-7.5926 l 50.776,-190.2913 c 1.898,-6.8808 6.643,-10.4399 14.236,-10.4399 h 83.994 c 7.237,0 10.914,3.5591 10.914,10.4399 0,6.9995 -3.677,10.4399 -10.914,10.4399 h -78.774 l -17.084,63.5886 h 51.726 c 6.88,0 10.439,3.5591 10.439,10.44 0,6.9995 -3.559,10.4399 -10.439,10.4399 z m 0,0",
    transform: "matrix(0,0.0329265,-0.0329265,0,0,-4e-6)",
    id: "path1361"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g1361"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-5",
    x: 139.56094,
    y: 626.24731,
    id: "use1361"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 19094.968,-4439.3384 c 1.898,-6.8808 6.644,-10.4399 14.237,-10.4399 h 65.486 c 11.033,0 20.643,4.7454 28.947,14.2363 8.542,9.2535 12.813,19.3375 12.813,30.3706 0,2.61 -0.475,5.22 -1.424,8.0672 l -27.998,105.8229 c -9.49,35.1161 -32.624,52.6741 -69.283,52.6741 h -65.486 c -3.204,0 -5.576,-0.9491 -7.119,-2.8473 -1.661,-2.1354 -1.898,-4.7454 -0.949,-7.5926 z m 19.456,10.4399 -45.556,168.9369 h 54.573 c 9.135,0 17.676,-2.9659 25.625,-9.0163 8.186,-5.9317 13.406,-13.4058 15.66,-22.3034 l 28.472,-105.8229 c 0.594,-2.8472 0.95,-5.3386 0.95,-7.5926 0,-7.2368 -2.373,-13.0499 -7.119,-17.5581 -4.745,-4.3895 -10.795,-6.6436 -18.032,-6.6436 z m 0,0",
    transform: "matrix(0,0.0329265,-0.0329265,0,0,-4e-6)",
    id: "path1362"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 195.68229,822.07813 v 23.68229 h -10.08333 v -23.68229 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1363"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg_);
export default __webpack_public_path__ + "static/media/план_кухня.e382b878f8e07116cd8d1626bdf69d77.svg";
export { ForwardRef as ReactComponent };